import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=390da2ee&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=390da2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390da2ee",
  null
  
)

export default component.exports